<template>
    <hts-slide-over
        :show="props.show"
        :title="$t('labels.driverHistory.title')"
        :width="50"
        @close="closeOverSide">
        <template #body>
            <div class="hts-coordinator-ignore-way__container-body">
                <hts-data-table
                    :headers="historyDriver"
                    :server="server"
                    :master-detail="true"
                    :is-row-master="isRowMaster"
                    :detail-cell-renderer="DriverHistoryDetail"
                    :detail-row-height="200" />
            </div>
        </template>
    </hts-slide-over>
</template>

<script lang="ts" setup>
import DriverHistoryDetail from './driver-history-detail.vue'
import steps from '@/data/coordiantor/tabs.json'

const props = defineProps({
  show: {
    type: Boolean,
    default: true,
    required: true
  },
  codeDriver: {
    type: String
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'screen-lg'
  },
  column: {
    type: Number,
    default: 3
  }
})
const store = $store()
const emits = defineEmits(['close'])
const historyDriver = [
  {
    field: 'updatedAt',
    label: 'updatedAt',
    headerName: $t('labels.driverHistory.dateChanges'),
    sortable: true,
    cellRenderer: 'agGroupCellRenderer',
    valueGetter: (params: any) => {
      return formatDate(params.data.updatedAt)
    }
  },
  {
    field: 'createdBy',
    label: 'createdBy',
    headerName: $t('labels.driverHistory.userCreateChange'),
    sortable: true,
    valueGetter: (params: any) => {
      const users: any[] = store.system.workspaceUsers
      if (users.length === 0) {
        return null
      }
      const user: { [key: string]: any } = computed(() => {
        return users.find((u) => u.user === params.data.createdBy)
      })
      return user.value.fullName
    }
  },
  {
    field: 'updatedBy',
    label: 'updatedBy',
    headerName: $t('labels.driverHistory.userChange'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.updatedBy) {
        return ''
      }
      const users: any[] = store.system.workspaceUsers
      if (users.length === 0) {
        return null
      }
      const user: { [key: string]: any } = computed(() => {
        return users.find((u) => u.user === params.data.updatedBy)
      })
      return user.value.fullName
    }
  },
  {
    field: 'action',
    label: 'action',
    headerName: $t('labels.driverHistory.action'),
    sortable: true,
    valueGetter: (params: any) => {
      let action = params.data.action
      switch (action) {
      case 'CREATE':
        action = 'Tạo mới'
        break
      case 'UPDATE':
        action = 'Chỉnh sửa'
        break
      case 'DELETE':
        action = 'Xóa'
        break
      default:
        break
      }
      return action
    }
  }
]

const server = ref({})
watch(
  () => props.codeDriver,
  (newValue, oldValue) => {
    server.value = {
      method: 'post',
      url: '/driver/history/' + newValue
    }
  }
)

const closeOverSide = () => {
  emits('close')
}

const isRowMaster = (dataItem: any) => {
  if (dataItem.action === 'CREATE') {
    return false
  }
  return true
}

const formatDate = (date: any) => {
  const slicePosition = date.toString().indexOf('T')
  if (!slicePosition) {
    return null
  }
  const newDate = date.slice(0, slicePosition).split('-').reverse().join('-')
  return newDate
}
</script>
